import { ListItem, ListItemText, Stack } from "@mui/material";
import React from "react";

import { DiscList } from "components/common/DiscList/DiscList";
import { HelpMessage } from "new-components/helpMessage/HelpMessage";

type EmptyStateProps = {
  firstListItem: string;
}

export function EmptyState({ firstListItem }: EmptyStateProps) {
  return (
    <Stack className="max-w-[705px] w-full m-auto h-full absolute z-10 left-0 right-0 flex justify-center">
      <DiscList
        sx={{
          color: "#49494D",

          "& .MuiListItemText-primary": {
            fontSize: "24px",
          },
        }}
      >
        <ListItem>
          <ListItemText
            primary={firstListItem}
          />
        </ListItem>

        <ListItem>
          <ListItemText
            primary={
              <HelpMessage startText="Need some help?" topic="with any questions about how to integrate Groundlight into your application." />
            }
          />
        </ListItem>
      </DiscList>
    </Stack>
  );
}
